// @flow
import type {FileComponents} from 'docs/data/integration-builder';
import * as React from 'react';

export const getVisibleFiles = (
  files: FileComponents,
): Array<React.Element<any>> => {
  // Have to do it this way instead of using Object.values to keep Flow happy
  // https://github.com/facebook/flow/issues/2221
  return Object.keys(files)
    .filter(
      (filename) =>
        !files[filename].props?.children?.props?.children?.props?.downloadOnly,
    )
    .map((filename) => files[filename]);
};
